import env from '../env';
import BaseService from './BaseService';

class SupplierMatchingService extends BaseService{};

export default new SupplierMatchingService('health_backend', 'match/suppliers');